// PostSubscribeAndUnlockButton.js
import { connect } from 'react-redux';

import PostSubscribeAndUnlockButton from '../component/PostSubscribeAndUnlockButton.jsx';

import sendUnlockMessage from '../action/sendUnlockMessage.js';
import login from '../action/login.js';
import addvalue from '../action/addvalue.js';
import openQuickpayModal from '../action/openQuickpayModal.js';

import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getMeData from '../selector/getMeData.js';
import getMeBalance from '../selector/getMeBalance.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getUnlockButtonStatus from '../selector/getUnlockButtonStatus.js';

import { NEED_AUTH_HANDLER } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { postId: messageId }) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const unlockPrice = getMessageData(state, messageId, 'unlockPrice');
  const unlockButtonStatus = getUnlockButtonStatus(state, messageId);
  const balance = getMeBalance(state);
  const isBalanceInsufficient = balance < unlockPrice;
  return {
    senderId,
    meId: getMeData(state, 'id'),
    unlockButtonStatus,
    unlockPrice,
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
    canViewMedia: getMessageData(state, messageId, 'canViewMedia'),
    needAuthHandler: getRemoteConfigData(state, NEED_AUTH_HANDLER),
    meSubscription: getUserData(state, senderId, 'meSubscription'),
    hasPurchased: getMeData(state, 'lastPurchased'),
    isBalanceInsufficient,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendUnlockMessage: ({ messageId, shouldCheckDrm, drmFeatureName }) =>
      dispatch(
        sendUnlockMessage({
          id: messageId,
          shouldCheckDrm,
          drmFeatureName,
        })
      ),
    login: () => dispatch(login({ isRequireDiamond: true })),
    addvalue: () => dispatch(addvalue({ via: 'post' })),
    openQuickpayModal: data => dispatch(openQuickpayModal(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PostSubscribeAndUnlockButton);
